import React from "react";
import { Plus, FileText, ArrowRight, Upload, Clock } from "lucide-react";

export default function EmptyProjectState({ setopenDialogue, hasPermission }) {
  return (
    <div className="flex items-center justify-center h-full min-h-[400px] w-full relative overflow-hidden ">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-32 h-32 bg-gradient-to-br from-blue-400 to-indigo-400 rounded-full animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-gradient-to-br from-slate-400 to-gray-400 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-10 w-16 h-16 bg-gradient-to-br from-green-400 to-emerald-400 rounded-full animate-pulse delay-500"></div>
      </div>

      <div className="text-center z-10 max-w-[700px] mx-auto px-6">
        {/* Main illustration */}
        <div className="relative mb-8">
          {hasPermission ? (
            <div
              className="w-32 h-32 mx-auto bg-blue-500 rounded-2xl shadow-2xl flex items-center justify-center transform hover:scale-105 transition-transform duration-300 cursor-pointer"
              onClick={() => setopenDialogue(true)}
            >
              <div className="w-20 h-20 bg-blue-700 rounded-xl flex items-center justify-center">
                <Plus className="w-10 h-10 text-white" strokeWidth={2} />
              </div>
            </div>
          ) : (
            <div className="w-32 h-32 mx-auto bg-gray-400 rounded-2xl shadow-2xl flex items-center justify-center">
              <div className="w-20 h-20 bg-gray-500 rounded-xl flex items-center justify-center">
                <Clock className="w-10 h-10 text-white" strokeWidth={2} />
              </div>
            </div>
          )}
        </div>

        {/* Text content */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-800">
            {hasPermission
              ? "No mapping projects yet"
              : "No projects assigned yet"}
          </h2>

          <p className="text-gray-500">
            {hasPermission
              ? "Create your first mapping project to transform and format your accounting files."
              : "There are no projects assigned to you yet. Thank you for your patience!"}
          </p>

          {/* Process steps - only show if user has permission */}
          {hasPermission && (
            <div className="flex items-center justify-center space-x-4 text-sm text-gray-400">
              <div className="flex items-center space-x-1">
                <FileText className="w-4 h-4" />
                <span>Create mapping</span>
              </div>
              <ArrowRight className="w-4 h-4" />
              <div className="flex items-center space-x-1">
                <Upload className="w-4 h-4" />
                <span>Upload file</span>
              </div>
              <ArrowRight className="w-4 h-4" />
              <div className="flex items-center space-x-1">
                <FileText className="w-4 h-4" />
                <span>Get formatted output</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
